import React from 'react'

const BtnExpenses = ({ setExpenses}) => {
  return (
    <button className="booking_btn" onClick={()=>setExpenses(true)}
    style={{
        display: 'block',
        width: '100%',
        padding: '12px 0',
        marginBottom: '8px',
        backgroundColor: '#949ca5',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        fontSize: "14px",
        cursor: 'pointer',
        fontWeight: "600",
    }}

>
    Extra Expenses
</button>
  )
}

export default BtnExpenses